/*
 * @Author: zwt.daffy
 * @Date: 2019-08-05 10:03:22
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2019-09-20 13:59:54
 * 园区管理接口
 */
import request from '@/api/base'

// 园区相关
const getAreaList = params => {
  return request.post('/ipark-admin/area/getAreaList', params)
}
const addZone = params => {
  return request.post('/ipark-admin/area/saveArea', params)
}
const editZone = params => {
  return request.post('/ipark-admin/area/updateArea', params)
}
const checkAreaExist = params => {
  return request.post('/ipark-admin/area/checkAreaExist', params)
}

// 管理员相关

const getAdminList = params => {
  return request.post('/ipark-admin/pvlg/pageEnterpriseCommonAdmin', params)
}
const getSuperManager = params => {
  return request.post('/ipark-admin/pvlg/getEnterpriseSuperAdmin', params)
  // return Promise.resolve({code: '200'})
}
const updateSuperManager = params => {
  return request.post('/enterprise/setEnterpriseManager', params)
}
const getManagerById = params => {
  return request.post('/ipark-admin/pvlg/getEnterpriseCommonAdminInfo', params)
}
const addManager = params => {
  return request.post('/ipark-admin/pvlg/addEnterpriseCommonAdmin', params)
}
const updateManager = params => {
  return request.post('/ipark-admin/pvlg/updateEnterpriseCommonAdmin', params)
}
const deleteManager = params => {
  return request.post('/ipark-admin/pvlg/delEnterpriseCommonAdmin', params)
}
const getAdminUserList = params => {
  return request.post('/ipark-admin/pvlg/canEnterpriseAdmin', params)
}

// 角色相关
const searchSystemRole = params => {
  return request.post('/ipark-admin/pvlg/listRolePage', params)
}
const addSystemRole = params => {
  return request.post('/ipark-admin/pvlg/addRole', params)
}
const editSystemRole = params => {
  return request.post('/ipark-admin/pvlg/updateRole', params)
}
const delSystemRole = params => {
  return request.post('/ipark-admin/pvlg/delRole', params)
}
const getMenuTreeList = params => {
  return request.post('/ipark-admin/pvlg/loadUserMenuAsTree', params)
}
const getRoleSelectedMenuTree = params => {
  return request.post('/ipark-admin/pvlg/loadRoleHasAssginMenu', params)
}
const setSystemRole = params => {
  return request.post('/ipark-admin/pvlg/assignMenu2Role', params)
}
const judgeRoleNameExist = params => {
  return request.post('/ipark-admin/pvlg/existRoleName', params)
}
// 普通用户授权操作
const auditToExtend = params => {
  return request.post('/ipark-admin/pvlg/auditToExtend', params)
}
// 普通用户失效操作
const invalidUser = params => {
  return request.post('/ipark-admin/pvlg/invalidUser', params)
}
// 保存普通用户授权操作
const saveAuditConfig = params => {
  return request.post('/ipark-admin/pvlg/saveAuditConfig', params)
}
// 获取普通用户授权操作
const getAuditConfig = params => {
  return request.post('/ipark-admin/pvlg/getAuditConfig', params)
}
export default {
  getAreaList,
  getSuperManager,
  updateSuperManager,
  addZone,
  editZone,
  getAdminList,
  updateManager,
  addManager,
  deleteManager,
  getAdminUserList,
  searchSystemRole,
  addSystemRole,
  editSystemRole,
  delSystemRole,
  getMenuTreeList,
  getRoleSelectedMenuTree,
  setSystemRole,
  judgeRoleNameExist,
  checkAreaExist,
  getManagerById,
  auditToExtend,
  invalidUser,
  saveAuditConfig,
  getAuditConfig
}



// WEBPACK FOOTER //
// ./src/area-common/api/zoneService.js